export default __webpack_public_path__ + "static/media/speech inactive.6d7b136d.svg";